export const FIELD_LABELS = {
	// --- Borrower ---
	Ssn: "SSN",
	Type: "Type",
	FirstName: "First Name",
	MiddleName: "Middle Name",
	LastName: "Last Name",
	Dob: "Date of Birth",
	IsUsCitizen: "U.S. Citizen",
	CellPhone: "Cell Phone",

	// --- Address ---
	Status: "Address Status",
	Address: "Street Address",
	City: "City",
	State: "State",
	ZipCode: "ZIP Code",
	TimeAtResYears: "Years at Residence",
	TimeAtResMonths: "Months at Residence",
	OwnershipType: "Ownership Type",
	MonthlyPmt: "Monthly Payment",

	// --- Employment ---
	CurrentEmploymnt: "Currently Employed",
	EmploymentStatus: "Employment Status",
	Name: "Company Name",
	ContactPhone: "Employer Phone",
	JobPos: "Position",
	TimeEmpYears: "Years Employed",
	TimeEmpMonths: "Months Employed",
	GrossMonthlyInc: "Gross Monthly Income",
	Income: "Income",
	Period: "Pay Period",

	// --- Vehicle Information ---
	EvalType: "Evaluation Type",
	Vin: "VIN",
	VehicleYear: "Vehicle Year",
	EvalDate: "Evaluation Date",
	VehicleTrim: "Trim",
	Make: "Make",
	Mileage: "Mileage",
	Model: "Model",
	Bookflag: "Book Flag",
	VehicleClass: "Vehicle Class",
	Mode: "Mode",
	Manual: "Manual Transmission",
	BaseValue1: "Base Value 1",
	MileageAdjValue1: "Mileage Adjustment 1",
	OptionsValue1: "Options Value 1",
	TotalValue1: "Total Value 1",
	ValueType1: "Value Type 1",
	BaseValue2: "Base Value 2",
	MileageAdjValue2: "Mileage Adjustment 2",
	OptionsValue2: "Options Value 2",
	TotalValue2: "Total Value 2",

	// --- Loan Request Information ---
	FinTypeCode: "Finance Type",
	Term: "Term (Months)",
	NbrPayments: "Number of Payments",
	TotalCashPrice: "Total Cash Price",
	DownPmt: "Down Payment",
	DocFee: "Documentation Fee",
	LicenseTagsReg: "License/Tags/Registration",
	SalesTax: "Sales Tax",
	AmtToFin: "Amount to Finance",
	ReqPmt: "Requested Payment",
	PmtFreq: "Payment Frequency",
	FicoScore: "FICO Score",
	TotalDebt: "Total Debt",
	TradeInAllow: "Trade-In Allowance",
	ServContractCode: "Service Contract Code",
	ServContractAmt: "Service Contract Amount",
	InterestRate: "Interest Rate",
	GapCode: "GAP Code",
	InsuranceTerm: "Insurance Term",
	InsuranceAmt: "Insurance Amount",
	GapInsAmt: "GAP Insurance Amount",
	OtherTaxable: "Other Taxable Items",
	OtherNonTaxable: "Other Non-Taxable Items",
	PayoffOnTrade: "Trade-In Payoff",
	Rebate: "Rebate",
};

export const REQUIRED_FIELDS = {
	Borrower: ["Ssn", "FirstName", "LastName", "Dob", "CellPhone", "IsUsCitizen"],
	BorrowerAddressLoanReq: [
		"Address",
		"City",
		"State",
		"ZipCode",
		"TimeAtResYears",
		"TimeAtResMonths",
		"OwnershipType",
		"MonthlyPmt",
	],
	BorrowerEmployments: [
		"Name",
		"ContactPhone",
		"JobPos",
		"TimeEmpYears",
		"TimeEmpMonths",
		"GrossMonthlyInc",
		"Income",
		"Period",
	],
	CoBorrower: [
		"Ssn",
		"FirstName",
		"LastName",
		"Dob",
		"CellPhone",
		"IsUsCitizen",
	],
	CoBorrowerAddressLoanReq: [
		"Address",
		"City",
		"State",
		"ZipCode",
		"TimeAtResYears",
		"TimeAtResMonths",
		"OwnershipType",
		"MonthlyPmt",
	],
	CoBorrowerEmployments: [
		"Name",
		"ContactPhone",
		"JobPos",
		"TimeEmpYears",
		"TimeEmpMonths",
		"GrossMonthlyInc",
		"Income",
		"Period",
	],

	Vehicle: [
		"Vin",
		"Make",
		"Model",
		"VehicleYear",
		"EvalType",
		"Mileage",
		"Bookflag",
		"VehicleClass",
		"Mode",
		"Manual",
		"BaseValue1",
		"MileageAdjValue1",
		"OptionsValue1",
		"TotalValue1",
		"ValueType1",
		"BaseValue2",
		"MileageAdjValue2",
		"OptionsValue2",
		"TotalValue2",
	],
	SaleInfo: [
		"FinTypeCode",
		"Term",
		"TotalCashPrice",
		"DownPmt",
		"AmtToFin",
		"ReqPmt",
		"PmtFreq",
		"FicoScore",
		"TotalDebt",
		"TradeInAllow",
		"ServContractCode",
		"ServContractAmt",
		"InterestRate",
		"GapCode",
		"InsuranceTerm",
		"InsuranceAmt",
		"GapInsAmt",
		"OtherTaxable",
		"OtherNonTaxable",
		"PayoffOnTrade",
		"Rebate",
	],
};
